var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1417 9.03015H3.80835V15.6968C3.80835 18.1968 4.64168 19.0302 7.14168 19.0302H13.8084C16.3084 19.0302 17.1417 18.1968 17.1417 15.6968V9.03015Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4166 6.53007V7.3634C18.4166 8.28007 17.9749 9.03007 16.7499 9.03007H4.24992C2.97492 9.03007 2.58325 8.28007 2.58325 7.3634V6.53007C2.58325 5.6134 2.97492 4.8634 4.24992 4.8634H16.7499C17.9749 4.8634 18.4166 5.6134 18.4166 6.53007Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 4.86339H5.59998C5.31665 4.55506 5.32498 4.08006 5.62498 3.78006L6.80832 2.59673C7.11665 2.2884 7.62498 2.2884 7.93332 2.59673L10.2 4.86339Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3917 4.86339H10.7917L13.0584 2.59673C13.3667 2.2884 13.8751 2.2884 14.1834 2.59673L15.3667 3.78006C15.6667 4.08006 15.6751 4.55506 15.3917 4.86339Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94995 9.03015V13.3135C7.94995 13.9802 8.68328 14.3718 9.24162 14.0135L10.025 13.4968C10.3083 13.3135 10.6666 13.3135 10.9416 13.4968L11.6833 13.9968C12.2333 14.3635 12.975 13.9718 12.975 13.3052V9.03015H7.94995Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.1993b610caa62a62f2baba7b744db3bb.svg";
export { ForwardRef as ReactComponent };